import { useCallback, useEffect, useState } from 'react';
import { dashboardAPI } from '../lib/api';

/** Loads dashboard KPIs + recent sessions. Exposes a `reload` for retry buttons. */
export const useDashboardStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await dashboardAPI.stats();
      setStats(res.data || {});
    } catch (err) {
      setStats({});
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { stats, loading, error, reload: load };
};
